export const stgConfig = {
  apiKey: 'AIzaSyDxCl3PhruPu5aVrxkHGcQumb06PpRO3f4',
  authDomain: 'gameon-conversations-stg.firebaseapp.com',
  projectId: 'gameon-conversations-stg',
  storageBucket: 'gameon-conversations-stg.appspot.com',
  messagingSenderId: '680181452765',
  appId: '1:680181452765:web:de12b91286b47d33f3f034',
};

export const prodConfig = {
  apiKey: 'AIzaSyA5He2wCVs2eG2DCKx7nAHIII4CuriCa3E',
  authDomain: 'gameon-conversations-prd.firebaseapp.com',
  projectId: 'gameon-conversations-prd',
  storageBucket: 'gameon-conversations-prd.appspot.com',
  messagingSenderId: '1035883127806',
  appId: '1:1035883127806:web:649e1a6501f94c816fd6af',
};
